// Here you can find definition of TradersYard REST API requests, responses and models.
// TODO: convert to modules

import { ChatConversationMessage } from './chat';

export namespace TradersYardApi {
    export namespace Chat {
        // TODO: interface ChatMessage

        export interface MessageContextResponse {
            messages?: ChatConversationMessage[];
            has_prev?: boolean;
            has_next?: boolean;
        }
    }

    export namespace Groups {
        export interface GroupSubscriptionPlan {
            plan_type: 'free' | 'pay_to_join';
            product_id: string;
        }
    }

    export namespace xYards {
        export enum xYardsOrderStatus {
            PENDING = 'pending',
            PROCESSING = 'processing',
            COMPLETED = 'completed',
        }

        export interface xYardsOrder {
            id: number; // internal ID
            entry: string;
            entry_id: number;
            user_id: number;
            wc_order_id: number;
            ty_order_key: string;
            wc_order_key: string;
            status: xYardsOrderStatus;
            created_at: string;
            updated_at: string;
            checkout_url: string;
        }
    }
}
